module.exports = __webpack_public_path__ + "static/covid-ef3bdb69c46a2ca75a92f54643b0b076.jpg";